@if (showNavigation) {
  <app-navigation>
    <router-outlet></router-outlet>
  </app-navigation>
}

@if (!showNavigation) {
  <router-outlet></router-outlet>
}
